import BaseLayout from "../layouts/BaseLayout";
import { Paper } from "@mui/material";

function PageNotFound() {
  return (
    <BaseLayout>
      <Paper elevation={0} sx={{ mt: 3, p: 3 }}>
        Page not found...
      </Paper>
    </BaseLayout>
  );
}

export default PageNotFound;
